import { CriticalInstrumentationDeletion, CriticalInstrumentationExecution } from '../model/criticalInstrumentation';
import { Execution } from '../model/execution';

export class CriticalInstrUtils {

  /**
   * QLOD-95. Apunta en la ejecucion la baja de una instrumentacion que venia del protocolo, con
   * la razon y los dos checks que marco el usuario, para que el back la de de baja y el informe
   * imprima la frase en el apartado elegido. Las que no vienen del protocolo no se apuntan: el
   * back las borra sin frase.
   */
  static registrarBaja(execution: Execution, cInst: CriticalInstrumentationExecution, reason: string,
    showDiffInDeviations: boolean, showDiffInObservations: boolean): void {
    if (execution == null || cInst == null || !cInst.fromProtocol || cInst.id == null) {
      return;
    }

    // La ejecucion llega del back como objeto plano: el valor inicial de la clase no aplica.
    execution.criticalInstrDeletions = (execution.criticalInstrDeletions ?? []).filter(d => d.id !== cInst.id);

    const baja = new CriticalInstrumentationDeletion();
    baja.id = cInst.id;
    baja.reason = reason;
    baja.showDiffInDeviations = showDiffInDeviations === true;
    baja.showDiffInObservations = showDiffInObservations === true;

    execution.criticalInstrDeletions.push(baja);
  }

}
